import React from 'react';
import './AuthPrompt.css';

export default function Welcome() {
  return (
    <div className="auth-container">
      <h2>Welcome to CLT Student Hub!</h2>
      <p>Your email has been confirmed. You can now log in.</p>
      <button 
        className="auth-option"
        onClick={() => window.location.href = '/login'}
      >
        Go to Login
      </button>
    </div>
  );
}